define(function (require) {

	//==================================================================================
    //=======================================[ Imports ]================================
    //==================================================================================

	var $ = require("jquery");
	require("bootstrap");
	require("carousel");

	//=================================================================================
    //=======================================[ Global ]================================
    //=================================================================================

	var g = {

	}

	//====================================================================================
    //=======================================[ Initialize ]===============================
    //====================================================================================

	$(function () {

		$.each($(".navigate-content"), function (index, elt) {
			$(elt).navigateCarousel({ autoScroll: true, autoScrollDelay: 6000, scrolIcon: 1 });
		});
		_initLexiqueScroll();
		parseStringToHtml();
	});

	//====================================================================================
    //=========================================[ Events ]=================================
    //====================================================================================

	$(function () {

		$(window).on('scroll', function (event) {
			followOnScroll(g.asideExpandedHeight);
		}).scroll();

		$('.btnChartEdito').on('click', function (e) {
			e.preventDefault();
			window.open($(this).attr('href'), 'windowCharteEditoriale', 'height=700, width=600, toolbar=no, menubar=no, scrollbars=yes, resizable=yes, location=no, directories=no, status=no');
		});

	});

	//====================================================================================
    //=======================================[ Functions ]================================
    //====================================================================================

	function _initLexiqueScroll() {
		var $lexique = $(".follow-scroll");
		if ($lexique.length > 0) {
			g.initialPositionY = $lexique.offset().top;

			//On met l'element en position relative pour pouvoir le deplacer
			$lexique.css('position', 'relative');

			g.marginTop = 30; //Hauteur pour ne pas qu'il soit collé
			g.hauteurContainerArticle = $("#container-article").height();
			var hauteurAsideScroll = $("#aside-scroll-article").height();
			g.asideExpandedHeight = $("#aside-scroll-article").height();
		}

		
	}
	
	function followOnScroll(hauteurAsideScroll) {
		var scrollTop = $(window).scrollTop();
		var currentScroll = scrollTop > g.initialPositionY ?  scrollTop - g.initialPositionY : 0;
		$(".follow-scroll").stop(false, false).animate({
			top: currentScroll > 0 ? (scrollTop - g.initialPositionY) + g.marginTop : currentScroll
		}, 500);
	}

	function parseStringToHtml() {
		$(".stringToHtml").each(function (i, el) {
			var targetContainer = $(this);
			var html = $.parseHTML(targetContainer.text(), true);
			$(targetContainer).html(html);
		});
	}
	

});
